// Example usage in a modal
import React from 'react';
import { Modal } from 'antd';
import { Profile } from 'models';
import { useGetDebtByIdQuery } from 'services';
import { FancySpinner } from 'components/common';
import { CustomerCreate } from 'models/Customer';
import { DebtDetailComponent } from 'components/Debt';
interface CustomerDetailModalProps {
  isOpen: boolean;
  onClose: () => void;
  debtid: string;
  customer: CustomerCreate;
  profile: Profile;
}

const CustomerDebtDetailModal: React.FC<CustomerDetailModalProps> = ({ debtid, isOpen, onClose }) => {
  const { data: datasaleorder, isLoading } = useGetDebtByIdQuery(
    {
      id: debtid ?? '',
      query: {
        includeRef: 'SaleOrders.saleOrderItems',
        include: 'status|debtAttachments.attachment',
      },
    },
    {
      skip: !debtid,
    },
  );

  return !isLoading ? (
    <Modal
      open={isOpen}
      onCancel={onClose}
      footer={null}
      width={1528}
      closeIcon={false}
      centered
      className='modal-none-padding'
    >
      {datasaleorder?.data && <DebtDetailComponent debtId={debtid} onClose={onClose} />}
    </Modal>
  ) : (
    <div className='fixed inset-0 flex items-center justify-center bg-white/70 z-50'>
      <FancySpinner size='large' colorScheme='blue' text='Đang tải dữ liệu...' overlay={true} />
    </div>
  );
};

export default CustomerDebtDetailModal;
